// Servicios para turnos de imágenes, adaptado para trabajar con estudios/equipos
import axios from "axios";
import dayjs from "dayjs";
import {
  borrarObjetosDuplicados,
  ordenarArrayObjetosByDate,
} from "../../utils/funcionalidadesArrays";

export const obtenerHorariosYTurnosImagenes = async (
  estudio,
  usuario,
  urlAxioPP,
) => {
  try {
    let agenda = [];
    let fechasTurnos = [];
    const agendaFiltradaPorRestriccion = [];
    let agendaPublicada = [];
    let turnosProximos = [];

    const config = {
      headers: { Authorization: `Bearer ${usuario.token}` },
    };

    if (estudio && estudio !== 0) {
      const url = `${urlAxioPP}Turnos/TurnosEquipo?mutual=${usuario.mutual}&estudio=${estudio}`;
      const response = await axios.get(url, config);

      if (response.data.length !== 0) {
        agenda = response.data;
      }

      // Mantener turnos publicados/no cancelados para mostrar ocupados/no disponibles
      // Incluimos todos los no cancelados (aunque turnosWeb sea false) para ver los reservados
      agendaPublicada = agenda.filter((turno) => !turno.cancelado);

      // Filtrar por fechas futuras y ventana de 2h en el día actual
      agendaPublicada = agendaPublicada
        .filter(
          (turno) =>
            dayjs(turno.fecha).isSame(dayjs()) ||
            dayjs(turno.fecha).isAfter(dayjs()),
        )
        .filter(
          (turno) =>
            dayjs().format("YYYY-MM-DD") !==
              dayjs(turno.fecha).format("YYYY-MM-DD") ||
            dayjs(turno.hora).format("HH:mm") >
              dayjs().add(2, "hour").format("HH:mm"),
        );

      // Disponibles = libres, no cancelados y turnosWeb habilitado
      const agendaDisponibles = agendaPublicada.filter(
        (turno) => turno.libre && turno.turnosWeb,
      );

      if (agendaDisponibles.length > 0) {
        agendaDisponibles.forEach((turno) =>
          agendaFiltradaPorRestriccion.push(turno),
        );
      }

      // Obtener fechas únicas con turnos disponibles
      borrarObjetosDuplicados(
        agendaFiltradaPorRestriccion,
        "fecha",
        true,
      ).forEach((turno) => {
        if (turno) {
          fechasTurnos.push({ fecha: turno, esFeriado: false });
        }
      });

      if (fechasTurnos.length > 0) {
        fechasTurnos.forEach((fecha) => {
          const fechaTurno = dayjs(fecha.fecha).format("YYYY-MM-DD");
          turnosProximos.push({
            date: fechaTurno,
            cantTurnos: agendaFiltradaPorRestriccion.filter((turno) =>
              dayjs(turno.fecha).isSame(fecha.fecha),
            ).length,
            textColor: "#800080",
            backgroundColor: "#ffc0cb",
          });
        });
      }

      return {
        success: true,
        turnosProximos: ordenarArrayObjetosByDate(turnosProximos, "date"),
        turnosDisponibles: ordenarArrayObjetosByDate(
          agendaFiltradaPorRestriccion,
          "hora",
        ),
        turnosPublicados: ordenarArrayObjetosByDate(agendaPublicada, "hora"),
        fechaSeleccionada:
          turnosProximos.length > 0
            ? ordenarArrayObjetosByDate(turnosProximos, "date")[0].date
            : "",
      };
    }

    return {
      success: false,
      error: "No se especificó un estudio válido",
      turnosProximos: [],
      turnosDisponibles: [],
      fechaSeleccionada: "",
    };
  } catch (error) {
    console.error("[ERROR] obtenerHorariosYTurnosImagenes:", error.message);
    return {
      success: false,
      error: error.message,
      turnosProximos: [],
      turnosDisponibles: [],
      fechaSeleccionada: "",
    };
  }
};

export const manejarReservaTurnoImagenes = async (
  turnoSeleccionado,
  usuario,
  estudioSeleccionado,
  urlAxioPP,
) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${usuario.token}` },
    };

    if (turnoSeleccionado) {
      const actualizarTurnoResponse = await axios.patch(
        `${urlAxioPP}Turnos/DarTurno/${turnoSeleccionado.codigo}`,
        {
          codigo: turnoSeleccionado.codigo,
          paciente: usuario.codigo,
          mutual: usuario.mutual,
          prestador: 0,
          estudio: estudioSeleccionado,
          equipo: turnoSeleccionado.equipo,
          telemedicina: turnoSeleccionado.telemedicina,
          observaciones: "Turno reservado via web por el paciente",
        },
        config,
      );

      if (
        actualizarTurnoResponse.status === 200 &&
        actualizarTurnoResponse.statusText === "OK"
      ) {
        return { success: true, mensaje: "El turno se reservó correctamente" };
      } else {
        return {
          success: false,
          mensaje: "Ocurrió un problema al intentar reservar el turno",
        };
      }
    }
  } catch (error) {
    console.error("[manejarReservaTurnoImagenes] Error:", error);
    return {
      success: false,
      mensaje:
        error.response?.data || "Error al reservar el turno: " + error.message,
    };
  }
};
